export const RATE_COMMAND_TTL_MS = 4000;

export function rememberRateCommand(commands, command, now = Date.now()) {
  return [...commands.filter((item) => now - item.at < RATE_COMMAND_TTL_MS), command].slice(-12);
}

export function matchRecentRateCommand(commands, rate, now = Date.now()) {
  for (let index = commands.length - 1; index >= 0; index -= 1) {
    const command = commands[index];
    if (now - command.at >= RATE_COMMAND_TTL_MS) continue;
    if (Math.abs(command.rate - rate) < 0.01) return command;
  }
  return null;
}
